module.exports = {"130171010":"长江街道","130171011":"太行街道","130171100":"宋营镇","130171101":"郄马镇"}


//////////////////
// WEBPACK FOOTER
// ./src/town/130171.json
// module id = 161
// module chunks = 0